// this is here because we decided to do everything on the client side.
// once backend integration happens this file will get deleted

export const RelevantLinksData = [
  {
    key: 'bewerbung',
    title: 'Bewerbung',
  },
  {
    key: 'gehalt',
    title: 'Gehalt',
  },
  {
    key: 'fuhrung-und-management',
    title: 'Führung und Management',
  },
  {
    key: 'arbeitsrecht',
    title: 'Arbeitsrecht',
  },
  {
    key: 'frau-macht-karriere',
    title: 'Frau macht Karriere',
  },
];
